import {
  DatePickerInputField,
  InputField,
  SelectField,
  TextareaField,
} from '../../../../components/FormikFields';
import MultipleFileUpload from '../../../../components/FormikFields/MultipleFileUpload/MultipleFileUpload';
import { SELECT_AN_OPTION_LABEL } from '../../../../constants/common';
import { FAILURE_TYPES, getAvailableTimeOptions } from '../../config/constants';
import styles from './ReportFailure.styles.scss';
import SelectFieldImp from '../../../../components/FormikFields/SelectFieldImp';

export const reportFailureFormConfig = ({
  t,
  lang,
  setFieldValue,
  setTouched,
  values,
}) => [
  {
    title: t('failure_notification.technical_failure_details'),
    fields: [
      {
        name: 'faliureType',
        label: t('failure_notification.failure_type'),
        component: SelectFieldImp,
        componentProps: {
          options: [
            {
              value: SELECT_AN_OPTION_LABEL,
              label: t('failure_notification.failure_type_placeholder'),
              disabled: true,
            },
            ...FAILURE_TYPES({ lang }),
          ],
        },
        required: true,
      },
      {
        name: 'solutionProviderName',
        label: t('failure_notification.solution_provider_name'),
        component: InputField,
        tooltip: t('failure_notification.tooltips.solutionProviderName'),
        componentProps: {
          placeholder: t(
            'failure_notification.solution_provider_name_placeholder',
          ),
        },
        required: true,
      },
      {
        name: 'technicalFailureDescription',
        label: t('failure_notification.technical_failure_description'),
        tooltip: t('failure_notification.tooltips.technicalFailureDescription'),
        component: TextareaField,
        componentProps: {
          placeholder: t(
            'failure_notification.technical_failure_description_placeholder',
          ),
        },
        required: true,
      },
      {
        name: 'supportingDocuments',
        label: t('failure_notification.upload_supporting_documents'),
        tooltip: t('failure_notification.tooltips.report_supportingDocuments'),
        component: MultipleFileUpload,
        componentProps: {
          acceptedFileTypes: '.jpg, .jpeg, .pdf, .png, .xls, .xlsx, .xlsm',
          fileTypeErrorMessage: t(
            'failure_notification.invalid_file_type_message',
          ),
          placeholder: t(
            'failure_notification.supporting_documents_placeholder',
          ),
          maxFileSizeInMB: 5,
          maximumFiles: 3,
          values,
          setFieldValue,
          setTouched,
        },
      },
    ],
  },
  {
    title: t('failure_notification.technical_failure_timeline'),
    fields: [
      {
        name: 'technicalFailureDate',
        label: t('failure_notification.technical_failure_date'),
        tooltip: t('failure_notification.tooltips.technicalFailureDate'),
        component: DatePickerInputField,
        componentProps: {
          className: 'w-100',
          placeholder: t('failure_notification.date_of_failure_placeholder'),
          maxDate: new Date(),
          dateFormat: 'YYYY-MM-DD',
          displayFormat: 'dd M yy',
        },
        required: true,
      },
      {
        name: 'technicalFailureTime',
        label: t('failure_notification.time_of_failure'),
        tooltip: t('failure_notification.tooltips.technicalFailureTime'),
        component: SelectField,
        componentProps: {
          className: styles.clockSelect,
          options: [
            {
              value: SELECT_AN_OPTION_LABEL,
              label: t('failure_notification.time_of_failure_placeholder'),
            },
            ...getAvailableTimeOptions({
              t,
              selectedDate: values.technicalFailureDate,
            }),
          ],
        },
        required: true,
      },
      {
        name: 'expectedResolutionDate',
        label: t('failure_notification.expected_resolution_date'),
        component: DatePickerInputField,
        componentProps: {
          className: 'w-100',
          placeholder: t(
            'failure_notification.expected_resolution_date_placeholder',
          ),
          minDate: new Date(),
          dateFormat: 'YYYY-MM-DD',
          displayFormat: 'dd M yy',
        },
        required: true,
      },
    ],
  },
];
